var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customer)?_c('div',[_c('h3',[_vm._v("\n    "+_vm._s(_vm.customer.name)+"\n    "),(!_vm.customer.user.verified)?_c('div',{staticClass:"fas fa-times times-black"}):_c('div',{staticClass:"circle",class:{ 'circle--online': _vm.online }}),_vm._v(" "),(_vm.no_offline_email)?_c('span',[_c('s',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip:auto",value:(_vm.no_offline_email_tooltip),expression:"no_offline_email_tooltip",arg:"auto"}],staticClass:"fas fa-envelope red"})])]):_vm._e(),_vm._v(" "),(_vm.isDeleted)?_c('span',{staticClass:"badge badge-deleted ml-3"},[_vm._v("gelöscht")]):_vm._e(),_vm._v(" "),(_vm.isDeletion)?_c('span',{staticClass:"badge badge-deletion ml-3"},[_vm._v("in Löschfrist")]):_vm._e(),_vm._v(" "),(_vm.isDisabled)?_c('span',{staticClass:"badge badge-disabled ml-3"},[_vm._v("gesperrt")]):_vm._e()]),_vm._v(" "),(_vm.isDeleted)?_c('p',[_vm._v("Gelöscht am: "+_vm._s(_vm.deleted_at))]):_vm._e(),_vm._v(" "),(_vm.isDeletion)?_c('p',[_vm._v("\n    Löschfrist seit: "+_vm._s(_vm.deletion_start_at)+"\n    "),_c('br'),_vm._v("\n    Bereits in Löschfrist: "+_vm._s(_vm.deletion_time)+"\n    "),_c('br'),_vm._v("\n    Löschfrist Ende: "+_vm._s(_vm.deletion_end_at)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.isDisabled)?_c('p',[_vm._v("\n    Gesperrt am: "+_vm._s(_vm.disabled_at)+"\n    "),_c('br'),_vm._v("\n    Grund: "+_vm._s(_vm.customer.user.disabled_message)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-grow-1"},[_c('h4',[(_vm.isUnsubscribed)?_c('span',{staticClass:"badge badge-warning ml-3"},[_vm._v("unsubscribed")]):_vm._e()])]),_vm._v(" "),(!_vm.isDeleted)?_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.loginAsUser()}}},[_vm._v("\n        Einloggen als\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$modal.show(_vm.openChatModalName)}}},[_vm._v("\n        Nachricht senden\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$modal.show(_vm.sendSupportMessageModalName)}}},[_vm._v("\n        Supportnachricht senden\n      ")]),_vm._v(" "),(_vm.isBlockedForMails)?_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.removeUserEmailLock()}}},[_vm._v("\n        E-Mail-Sperre aufheben\n      ")]):_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$modal.show(_vm.sendMailModalName)}}},[_vm._v("\n        E-Mail senden\n      ")]),_vm._v(" "),(_vm.isSuperadmin)?_c('v-button',{staticClass:"btn btn-warning",attrs:{"working":_vm.loggingOut},nativeOn:{"click":function($event){return _vm.logoutUser()}}},[_vm._v("Zwangslogout")]):_vm._e(),_vm._v(" "),_c('v-button',{staticClass:"btn btn-danger",attrs:{"working":_vm.deleting},nativeOn:{"click":function($event){return _vm.deleteUser(_vm.customer.name)}}},[_vm._v("Löschen")]),_vm._v(" "),(_vm.isSuperadmin)?_c('v-button',{staticClass:"btn btn-danger",attrs:{"working":_vm.deleting},nativeOn:{"click":function($event){return _vm.forceDeleteUser(_vm.customer.name)}}},[_vm._v("Hart Löschen")]):_vm._e(),_vm._v(" "),_c('v-button',{staticClass:"btn btn-danger",attrs:{"working":_vm.settingUserDisabled},nativeOn:{"click":function($event){return _vm.toggleUserDisabled.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.userDisabledText))])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('resource',{attrs:{"resource":"customerProfile","original":_vm.customer,"static-mode":true,"attributes":[
          {
            name: 'id',
            label: 'ID',
            type: 'StaticText'
          },
          {
            name: 'name',
            label: 'Name',
            type: 'StaticText'
          },
          {
            name: 'created_at',
            label: 'Registrierung',
            type: 'StaticText'
          },
          {
            name: 'last_login_at',
            label: 'letzter Login',
            type: 'StaticText'
          },
          {
            name: 'last_seen_at',
            label: 'letzte Besucheraktion',
            type: 'StaticText'
          },
          {
            name: 'last_seen_on',
            label: 'Zeit der letzten Aktion',
            type: 'StaticText'
          },
          {
            name: 'user',
            label: 'Verified',
            type: 'UserVerified'
          },
          {
            name: 'user|unsubscribed',
            label: 'Unsubscribed',
            type: 'StaticText',
            hideEmpty: true
          },
          {
            name: 'user|email_restricted',
            label: 'Email-Versand gesperrt',
            type: 'StaticText',
            hideEmpty: true
          },
          {
            name: 'balance',
            label: 'Währung vorhanden',
            type: 'StaticText'
          },
          {
            name: 'spent',
            label: 'Währung ausgegeben',
            type: 'StaticText'
          },
          {
            name: 'ins',
            label: 'INs (heute / total)',
            type: 'StaticText',
            isString: true
          },
          {
            name: 'outs',
            label: 'OUTs (heute / total)',
            type: 'StaticText',
            isString: true
          },
          {
            name: 'user|source',
            label: 'Quelle',
            type: 'StaticText',
            isString: true
          },
          {
            name: 'telegram_token',
            label: 'Telegram',
            type: 'TelegramConnection'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Stammdaten")])]),_vm._v(" "),(!_vm.customer.user.verified && !_vm.isDeleted)?_c('v-button',{staticClass:"btn-primary",attrs:{"working":_vm.sendingVerificationEmail,"type":"button"},nativeOn:{"click":function($event){return _vm.sendVerifcationEmail.apply(null, arguments)}}},[_vm._v("\n          Aktiveriungsemail erneut senden\n        ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.isDeleted},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing)return;_vm.email=$event.target.value}}})]),_vm._v(" "),(!_vm.isDeleted)?_c('v-button',{staticClass:"btn-primary float-right",attrs:{"working":_vm.changingEmail,"type":"button"},nativeOn:{"click":function($event){return _vm.persistEmail()}}},[_vm._v("Speichern")]):_vm._e()],1)]),_vm._v(" "),(!_vm.isDeleted)?_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing)return;_vm.password=$event.target.value}}})]),_vm._v(" "),_c('v-button',{staticClass:"btn-primary float-right",attrs:{"type":"button"},nativeOn:{"click":function($event){return _vm.persistPassword()}}},[_vm._v("Speichern")])],1)]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.isDeleted)?_c('resource',{attrs:{"title":"Ändern","resource":"customerProfile","resourceName":"Mitglied","original":_vm.customer,"attributes":[
          {
            name: 'sex',
            label: 'Geschlecht',
            type: 'SexSelector'
          },
          {
            name: 'name',
            label: 'Name',
            checkChanged: true
          },
          {
            name: 'country_iso3166',
            label: 'Land',
            type: 'OptionSelector'
          },
          {
            name: 'zipcode',
            label: 'PLZ',
            col: 3
          },
          {
            name: 'birthday',
            label: 'Geburtsdatum',
            type: 'BirthdaySelector',
            withRandomSelector: false
          },
          {
            name: 'physique',
            label: 'Figur',
            type: 'OptionSelector'
          },
          {
            name: 'i_search_for_activity',
            label: 'Ich suche',
            type: 'MultiOptionSelector',
            multiSelect: true
          },
          {
            name: 'interested_in_gender',
            label: 'Interessiert an',
            type: 'SexSelector',
            multiSelect: true
          },
          {
            name: 'height_in_cm',
            label: 'Größe (cm)',
            type: 'SliderSelector',
            max: 220,
            min: 140
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Profil bearbeiten")])])]):_vm._e()],1)]),_vm._v(" "),(!_vm.isDeleted)?_c('MediaEditCard',{attrs:{"profile":_vm.customer}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-7"},[_c('v-table',{attrs:{"url":'/api/v1/friends/' + _vm.id,"filter":[
          {
            name: 'where',
            attributes: {
              customer_profile_id1: _vm.id,
              accepted: 1
            }
          },
          {
            name: 'with',
            value: ['receiver']
          }
        ],"attributes":[
          {
            attribute: 'receiver',
            type: 'LinkFriendCell',
            name: 'Freund'
          },
          {
            attribute: 'receiver.type',
            name: 'Fake',
            type: 'CheckMarkerCell'
          },
          {
            name: 'Aktion',
            type: 'DeleteFriendCell'
          }
        ]}})],1),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-table',{attrs:{"url":'/api/v1/friends/' + _vm.id,"filter":[
              {
                name: 'where',
                attributes: {
                  customer_profile_id1: _vm.id,
                  accepted: null
                }
              },
              {
                name: 'with',
                value: ['receiver']
              }
            ],"attributes":[
              {
                attribute: 'receiver',
                type: 'LinkFriendCell',
                name: 'Freund'
              },
              {
                attribute: 'receiver.type',
                name: 'Fake',
                type: 'CheckMarkerCell'
              },
              {
                name: 'Aktion',
                type: 'DeleteFriendCell'
              }
            ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Offene gesendet")])]),_vm._v(" "),_c('v-table',{attrs:{"url":'/api/v1/friends/' + _vm.id,"filter":[
              {
                name: 'where',
                attributes: {
                  customer_profile_id2: _vm.id,
                  accepted: null
                }
              },
              {
                name: 'with',
                value: ['sender']
              }
            ],"attributes":[
              {
                attribute: 'sender',
                type: 'LinkFriendCell',
                name: 'Freund'
              },
              {
                attribute: 'sender.type',
                name: 'Fake',
                type: 'CheckMarkerCell'
              },
              {
                name: 'Aktion',
                type: 'DeleteFriendCell'
              }
            ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Offene eingehend")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-table',{attrs:{"url":"/api/v1/transaction","filter":[
          {
            name: 'where',
            attributes: {
              customer_profile_id: _vm.id,
              amount: {
                operator: '>',
                value: 0
              }
            }
          }
        ],"attributes":[
          {
            attribute: 'id',
            name: 'ID',
            type: 'TransactionLinkCell'
          },
          {
            type: 'DateTimeCell',
            attribute: 'paid_at',
            name: 'Datum'
          },
          {
            attribute: 'amount',
            name: 'Einheiten'
          },
          {
            type: 'CurrencyCell',
            attribute: 'price',
            name: 'Preis'
          },
          {
            attribute: 'service_string',
            name: 'Methode'
          },
          {
            attribute: 'service_transaction_id',
            name: 'Buchungs-/Transaktionsnummer'
          },
          {
            type: 'TransactionConfirmCell',
            attribute: 'state',
            name: 'Gebucht?'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Transaktionen")])])],1)]),_vm._v(" "),(!_vm.isDeleted)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('allowed-payment-methods',{attrs:{"user":_vm.customer.user}})],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-table',{attrs:{"url":"/api/v1/message","filter":[
          {
            name: 'with',
            value: ['sender', 'receiver', 'transaction']
          },
          {
            name: 'where',
            attributes: {
              sender_id: _vm.id
            }
          }
        ],"attributes":[
          {
            attribute: 'id',
            name: 'ID'
          },
          {
            attribute: 'receiver',
            type: 'LinkFriendCell',
            name: 'Chatpartner'
          },
          {
            type: 'DialogLink',
            name: 'Dialog'
          },
          {
            attribute: 'in',
            name: 'IN/OUT',
            type: 'InOrOutCell'
          },
          {
            name: 'Inhalt',
            type: 'MessageContentCell'
          },
          {
            attribute: 'dEType',
            name: 'Typ'
          },
          {
            attribute: 'transaction.amount',
            name: 'Einheiten'
          },
          {
            attribute: 'created_at',
            name: 'Gesendet am',
            type: 'DateTimeCell'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Nachrichten")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('customer-dialogs-table',{attrs:{"customer":_vm.customer}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-table',{attrs:{"url":"/api/v1/logEntry","filter":[
          {
            name: 'where',
            attributes: {
              user_id: _vm.customer.user.id
            }
          },
          {
            name: 'navigation'
          }
        ],"attributes":[
          {
            attribute: 'method',
            name: 'Method'
          },
          {
            attribute: 'route',
            name: 'Route'
          },
          {
            attribute: 'values',
            name: 'Parameter'
          },
          {
            attribute: 'created_at',
            name: 'Vom',
            type: 'DateTimeCell'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Navigation")])])],1)]),_vm._v(" "),(!_vm.isDeleted)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-table',{attrs:{"url":"/api/v1/userSession","filter":[
          {
            name: 'where',
            attributes: {
              user_id: _vm.customer.user.id
            }
          }
        ],"attributes":[
          {
            attribute: 'ip',
            name: 'IP-Adresse'
          },
          {
            attribute: 'country_code',
            name: 'Land',
            type: 'FlagCell'
          },
          {
            attribute: 'session_id',
            name: 'Session-ID'
          },
          {
            attribute: 'user_agent',
            name: 'Browser- und Gerätedaten'
          },
          {
            attribute: 'created_at',
            name: 'Erstellt am',
            type: 'DateTimeCell'
          },
          {
            attribute: 'closed_at',
            name: 'Geschlossen am',
            type: 'DateTimeCell'
          },
          {
            attribute: 'duration',
            name: 'Zeitspanne'
          },
          {
            attribute: 'success',
            name: 'Erfolgreich eingeloggt',
            type: 'CheckMarkerCell'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Anmeldungen")])])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v2-table',{attrs:{"url":`/api/v1/emailLog?filter[to]=${_vm.customer.user.email}&paginate`,"headers":[
          {
            text: 'Id'
          },
          {
            text: 'User'
          },
          {
            text: 'Betreff'
          },
          {
            text: 'Typ'
          },
          {
            text: 'Datum'
          },
          {
            text: 'Nachricht'
          }
        ]},scopedSlots:_vm._u([{key:"row",fn:function({ item }){return _c('tr',{},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('e-mail-log-to-cell',{attrs:{"model":item,"content":item.to}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.subject))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('date-time-cell',{attrs:{"content":item.created_at}}),_vm._v(" "),_c('modal-cell',{attrs:{"attribute":{ mode: 'emailLog', modal: 'EMailLogModal' },"model":item}})],1)}}],null,false,3516611487)})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-table',{attrs:{"url":"/api/v1/emailBounce","filter":[
          {
            name: 'where',
            attributes: {
              user_id: _vm.customer.user.id
            }
          }
        ],"attributes":[
          {
            attribute: 'bounced_email_address',
            name: 'problematische Email-Adresse'
          },
          {
            attribute: 'bounce_reason',
            name: 'Grund'
          },
          {
            attribute: 'created_at',
            name: 'Zurück gekommen am',
            type: 'DateTimeCell'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Zurückgekommene Emails")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('resource',{attrs:{"resource":"customerProfile","notification":"Die Notizen wurden gespeichert","original":_vm.customer,"attributes":[
          {
            name: 'internal_notes',
            label: 'Intern (admin -> admin)',
            type: 'TextareaSelector',
            rows: 5
          },
          {
            name: 'admin_notes',
            label: 'Admininfo (admin -> moderator)',
            type: 'TextareaSelector',
            rows: 5
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Notizen")])])])],1),_vm._v(" "),(!_vm.isDeleted)?_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"card"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('customer-settings-notification',{attrs:{"is-admin":true,"user":_vm.customer.user,"telegram-token":_vm.customer.telegram_token}})],1)])]):_vm._e()]),_vm._v(" "),_c('modal',{attrs:{"name":_vm.sendMailModalName}},[_c('section',{staticClass:"p-3"},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.mailMessage),expression:"mailMessage"}],staticClass:"form-control",attrs:{"placeholder":"Nachricht ..."},domProps:{"value":(_vm.mailMessage)},on:{"input":function($event){if($event.target.composing)return;_vm.mailMessage=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.disableModalActions},on:{"click":function($event){return _vm.sendMail()}}},[_vm._v("\n        Senden\n      ")])])]),_vm._v(" "),_c('modal',{attrs:{"name":_vm.sendSupportMessageModalName}},[_c('section',{staticClass:"p-3"},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.supportMessage),expression:"supportMessage"}],staticClass:"form-control",attrs:{"placeholder":"Nachricht ..."},domProps:{"value":(_vm.supportMessage)},on:{"input":function($event){if($event.target.composing)return;_vm.supportMessage=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.disableModalActions},on:{"click":function($event){return _vm.sendSupportMessage()}}},[_vm._v("\n        Senden\n      ")])])]),_vm._v(" "),_c('modal',{staticClass:"chat-modal",attrs:{"name":_vm.openChatModalName,"width":'70%',"height":'70%'},on:{"before-open":_vm.loadChatProfiles}},[_c('section',{staticClass:"p-3",staticStyle:{"height":"80%"}},[_c('div',{staticClass:"form-group"},[(_vm.chatProfiles.length > 0)?_c('autocomplete',{attrs:{"id":"chatPartnerSelect","inputClass":"form-control","list":_vm.chatProfiles,"property":"name","threshold":2},model:{value:(_vm.profileName),callback:function ($$v) {_vm.profileName=$$v},expression:"profileName"}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.startChat()}}},[_vm._v("\n          Chat starten\n        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1),_vm._v(" "),(_vm.chatActive)?_c('dialog-content',{key:_vm.counter,attrs:{"hideInputs":_vm.isDeleted,"isAsa":false,"idPartner":_vm.customer.id,"profile":_vm.selectedChatProfile,"support":false,"moderator":true},on:{"message-sent":_vm.updateDialog}}):_vm._e()],1)])],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("E-Mail-Adresse")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("Passwort")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("Verwendbare Bezahlmethoden")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("Einstellungen")])])
}]

export { render, staticRenderFns }